import styled from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const Divider = styled.div`
  width: auto;
  height: 1px;
  background-color: var(--border-main);
`;

export const SectionWrapper = styled.div`
  padding: 25px 40px 25px 40px;
  color: var(--textAndLabels-main);

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 20px 16px;
  }
`;

export const NavigationItemWrapper = styled.div`
  ${flexColumn};
  row-gap: 24px;
  color: var(--textAndLabels-main);
`;
